import { render, staticRenderFns } from "./ehc-unpublished-overlay.vue?vue&type=template&id=4dbf89ce"
import script from "./ehc-unpublished-overlay.vue?vue&type=script&lang=js"
export * from "./ehc-unpublished-overlay.vue?vue&type=script&lang=js"
import style0 from "./ehc-unpublished-overlay.vue?vue&type=style&index=0&id=4dbf89ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports